import { useCallback, useMemo } from 'react'
import { useMemberPortalApi } from './memberPortalApiClient'
import { getApiBase } from '@/utils/apiBase'

export function useMemberVotingApi() {
  const { memberPortalApiGet, memberPortalApiPost } = useMemberPortalApi()

  const listOpenMotions = useCallback(
    async (clubCode) => {
      const res = await memberPortalApiGet(`/api/members-portal/${clubCode}/voting/motions`)
      const json = await res.json()
      if (!json?.ok) {
        throw new Error(json?.error || 'member_voting_list_failed')
      }
      return json.data || []
    },
    [memberPortalApiGet]
  )

  const getMotionDetail = useCallback(
    async (clubCode, motionId) => {
      const res = await memberPortalApiGet(`/api/members-portal/${clubCode}/voting/motions/${motionId}`)
      const json = await res.json()
      if (!json?.ok) {
        throw new Error(json?.error || 'member_voting_detail_failed')
      }
      return json.data
    },
    [memberPortalApiGet]
  )

  const submitVote = useCallback(
    async (clubCode, motionId, vote) => {
      const res = await memberPortalApiPost(`/api/members-portal/${clubCode}/voting/motions/${motionId}/vote`, {
        vote,
      })
      const json = await res.json()
      if (!json?.ok) {
        const error = new Error(json?.error || 'member_voting_vote_failed')
        error.code = json?.error
        throw error
      }
      return json.data
    },
    [memberPortalApiPost]
  )

  return useMemo(
    () => ({
      listOpenMotions,
      getMotionDetail,
      submitVote,
    }),
    [listOpenMotions, getMotionDetail, submitVote]
  )
}

export async function verifyPublicBoardMotion({ clubCode, motionId, token, otpCode }) {
  const base = getApiBase()
  const res = await fetch(
    `${base}/api/public/board-motions/${encodeURIComponent(clubCode)}/${encodeURIComponent(motionId)}/verify`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, otp_code: otpCode }),
    }
  )
  const json = await res.json()
  if (!json?.ok) {
    const error = new Error(json?.error || 'board_motion_verify_failed')
    error.code = json?.error
    throw error
  }
  return json.data
}

export async function submitPublicBoardVote({ clubCode, motionId, token, otpCode, vote }) {
  const base = getApiBase()
  const res = await fetch(
    `${base}/api/public/board-motions/${encodeURIComponent(clubCode)}/${encodeURIComponent(motionId)}/vote`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, otp_code: otpCode, vote }),
    }
  )
  const json = await res.json()
  if (!json?.ok) {
    const error = new Error(json?.error || 'board_motion_vote_failed')
    error.code = json?.error
    throw error
  }
  return json.data
}
